module.exports = __webpack_public_path__ + "static/michael-min-2d496a4e8de08eebb344d5b4826e5d8e.png";